module.exports = __webpack_public_path__ + "8-summer-snow.3bb1825aa6617083c529.png";


//////////////////
// WEBPACK FOOTER
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/assets/images/festival/8-summer-snow.png
// module id = ../../../../../src/assets/images/festival/8-summer-snow.png
// module chunks = styles